<template>
    <b :class="rateColorClass">{{rate | num('0.00')}}</b>
</template>

<script>
import { round } from 'lodash'

export default {
    props: {
        rate: {
            required: true,
            type: Number
        }
    },
    computed: {
        rateIcon() {
            return 'numeric-' + round(this.rate) + '-circle-outline'
        },
        rateColorClass() {
            if (this.rate === 5) {
                return 'has-text-success-dark'
            } else if (this.rate >= 4) {
                return 'has-text-info'
            } else if (this.rate >= 3) {
                return 'has-text-warning'
            } else {
                return 'has-text-danger'
            }
        }
    }
}
</script>